module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/claims/claims.component.css
// module id = ./src/app/ultilities/claims/claims.component.css
// module chunks = main